import React, { useEffect } from 'react';
import { Carousel, CarouselControl, CarouselIndicators, CarouselItem } from 'reactstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import { useState } from 'react';
import Main from './middelware/Main';
import CentralizedService from './middelware/CentralizedService';
import Dashboard from './middelware/Dashboard';
import Logging from './middelware/Logging';
import Allday from './middelware/Allday';
import Interoperability from './middelware/Interoperability';
import { useTheme } from '@material-ui/styles';
import MainMobile from './middelware/MainMobile';
import CentralizedServiceMobile from './middelware/CentralizedServiceMobile';
import DashboardMobile from './middelware/DashboardMobile';
import LoggingMobile from './middelware/LoggingMobile';
import AlldayMobile from './middelware/AlldayMobile';
import InteroperabilityMobile from './middelware/InteroperabilityMobile';

const useStyles = makeStyles((theme) => ({
    section: {
        height: '100vh',
    },
    buttonControl: {
        filter: 'invert(1)'
    },
    indicators: {
        filter: 'invert(1)'
    },

}));

const items = [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }];

const slides = [
    { view: <Main /> },
    { view: <CentralizedService /> },
    { view: <Dashboard /> },
    { view: <Logging /> },
    { view: <Allday /> },
    { view: <Interoperability /> }].map((slide) =>
        <CarouselItem>
            {slide.view}
        </CarouselItem>);

const mobileSlides = [
    { view: <MainMobile /> },
    { view: <CentralizedServiceMobile /> },
    { view: <DashboardMobile /> },
    { view: <LoggingMobile /> },
    { view: <AlldayMobile /> },
    { view: <InteroperabilityMobile /> }].map((slide) =>
        <CarouselItem>
            {slide.view}
        </CarouselItem>);

const MiddlewareCarrousel = ({ visible }) => {

    const classes = useStyles();
    const theme = useTheme();
    const matchSM = useMediaQuery(theme.breakpoints.down('sm'));

    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        setActiveIndex(0);
    }, [visible])


    const handleNext = () => {
        !isLastSlide && setActiveIndex(activeIndex + 1);
    }

    const handlePrev = () => {
        !isFirstSlide && setActiveIndex(activeIndex - 1);
    }

    const isFirstSlide = activeIndex === 0;
    const isLastSlide = activeIndex === (slides.length - 1);


    return (
        <div className={classes.section}>
            <Carousel
                activeIndex={activeIndex}
                next={function noRefCheck() { }}
                previous={function noRefCheck() { }}
            >

                <CarouselIndicators className={classes.indicators} items={items} activeIndex={activeIndex} onClickHandler={(index) => setActiveIndex(index)} />

                {matchSM ? mobileSlides : slides}


                {
                    !isFirstSlide &&
                    <CarouselControl
                        direction="prev"
                        directionText="Previous"
                        onClickHandler={handlePrev}
                        className={classes.buttonControl} />
                }

                {
                    !isLastSlide &&
                    <CarouselControl
                        direction="next"
                        directionText="Next"
                        onClickHandler={handleNext}
                        className={classes.buttonControl} />
                }
            </Carousel>
        </div>);
};

export default MiddlewareCarrousel;